/** Reviewed help shared by the Insights cards: data references, notes and their sources. A shape change edits it in place. */
import * as z from 'zod';
const nonemptyId = z.string().trim().min(1).max(120);
export const insightCategoryRefSchema = z.strictObject({
    categoryKey: z.string().min(1),
    field: z.enum(['buyers', 'share']),
});
export const insightDatumRefSchema = z.union([
    z.strictObject({ measurement: nonemptyId }),
    insightCategoryRefSchema,
    z.strictObject({ bandKey: nonemptyId, field: z.enum(['buyers', 'share']) }),
]);
export const insightSourceRefSchema = z.discriminatedUnion('source', [
    z.strictObject({
        source: z.enum(['customers', 'orders', 'order_lines']),
        label: z.string().trim().min(1).max(120),
        syncedAt: z.iso.datetime({ offset: true }).nullable(),
    }),
    z.strictObject({
        source: z.literal('observedWindow'),
        label: z.string().trim().min(1).max(120),
        start: z.iso.datetime({ offset: true }).nullable(),
        end: z.iso.datetime({ offset: true }).nullable(),
    }),
]);
const unavailableReason = z.enum(['zero_base', 'source_contract_unavailable', 'no_known_categories']);
export const insightDisplayDatumSchema = z.strictObject({
    sourceRef: insightDatumRefSchema,
    label: z.string().trim().min(1).max(120),
    unit: z.enum(['count', 'proportion']),
    result: z.discriminatedUnion('state', [
        z.strictObject({ state: z.literal('available'), value: z.number().finite().nonnegative() }),
        z.strictObject({
            state: z.literal('unavailable'),
            reason: unavailableReason,
            message: z.string().trim().min(1).max(200),
        }),
    ]),
    baseRef: insightDatumRefSchema.optional(),
});
export const insightHelpNoteSchema = z.strictObject({
    code: nonemptyId,
    text: z.string().trim().min(1).max(500),
    values: z.array(insightDisplayDatumSchema),
    sources: z.array(insightSourceRefSchema),
});
export const insightCardHelpSchema = z.strictObject({
    appliesTo: z.array(insightDatumRefSchema),
    why: z.string().trim().min(1).max(500),
    how: z.string().trim().min(1).max(700),
    notes: z.array(insightHelpNoteSchema),
});
const emphasis = z.enum(['primary', 'supporting']);
const populationStepsCardSchema = z.strictObject({
    kind: z.literal('population-steps'),
    relationship: z.literal('nested-sets'),
    base: insightDisplayDatumSchema,
    help: insightCardHelpSchema.optional(),
    steps: z.tuple([
        z.strictObject({ datum: insightDisplayDatumSchema, emphasis: emphasis.optional() }),
        z.strictObject({ datum: insightDisplayDatumSchema, emphasis: emphasis.optional() }),
        z.strictObject({ datum: insightDisplayDatumSchema, emphasis: emphasis.optional() }),
    ]),
});
export const insightMetricCardSchema = z.strictObject({
    kind: z.literal('metric'),
    datum: insightDisplayDatumSchema,
    values: z.array(insightDisplayDatumSchema).optional(),
    emphasis: emphasis.optional(),
    help: insightCardHelpSchema.optional(),
});
export const insightDisplayCardSchema = z.discriminatedUnion('kind', [
    insightMetricCardSchema,
    populationStepsCardSchema,
]);
export const insightCardSectionSchema = z.strictObject({
    id: z.string().trim().min(1).max(80),
    title: z.string().trim().min(1).max(120),
    help: insightCardHelpSchema,
    cards: z.array(insightDisplayCardSchema).min(1),
});
export const insightCardPresentationSchema = z.strictObject({
    sections: z.array(insightCardSectionSchema).min(1),
});
//# sourceMappingURL=insight-presentation.js.map